import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faUserCircle } from "@fortawesome/free-solid-svg-icons"

export const UserCircle = (props) => {
  return <FontAwesomeIcon faIcon={faUserCircle} {...props} />
}
